import React from 'react';

/**
 * Reusable Metric Card Component
 * Displays a metric with label and optional badge
 * 
 * @param {string|ReactNode} label - Label text or React node
 * @param {string|number} value - Value to display
 * @param {string} badgeText - Optional badge text
 * @param {string} badgeTone - Badge tone (success, info, warning, etc.)
 * @param {boolean} labelStrong - Whether label should be strong/bold
 * @param {boolean} isLoading - Whether to show shimmer loader instead of value
 */
function MetricCard({ label, value, badgeText, badgeTone, labelStrong = false, isLoading = false }) {
  return (
    <s-box padding="base" background="base" border="base" borderRadius="base">
      <s-stack gap="small">
        {labelStrong ? (
          <s-text type="strong">{label}</s-text>
        ) : (
          <s-text color="subdued">{label}</s-text>
        )}
        {isLoading ? (
          <div className="shimmer-loader shimmer-heading" />
        ) : (
          <s-heading>{value}</s-heading>
        )}
        {badgeText && !isLoading && (
          <s-badge tone={badgeTone} size="base">{badgeText}</s-badge>
        )}
      </s-stack>
    </s-box>
  );
}

export default MetricCard;
